// src/routers/ProductionRouter.js
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuthRole from '../Hooks/useAuthRole'; // ✅ use the role hook (production OR above)

const ProductionRouter = ({ children, ...rest }) => {
  const { user, isLoading, isProductionPlus } = useAuthRole();
  // isProductionPlus === production OR above (based on ROLE_ORDER)

  if (isLoading) {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  const isSignedIn = !!user?.email;
  const canAccess = isSignedIn && isProductionPlus;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default ProductionRouter;
